// Module
var code = "<div ng-repeat=\"opt in $ctrl.options\"> <div> <input type=\"radio\" class=\"filled-in\" ng-model=\"$ctrl.selectedOption\" data-ng-value=\"opt.value\" is-checked=\"{{opt.value == $ctrl.selectedOption ? 'true' : 'false' }}\" disabled=\"disabled\"/> <label>{{opt.text}}</label> </div> </div> ";
// Exports
export default code;